/** Client-facing launch proof reference — never expose internal project/report slugs. */
const INTERNAL_REF_PATTERN = /^(project_|rpt_|run_|agency_|clt_|cl_)/i;
export function isInternalProofReferenceRef(value) {
    const trimmed = value.trim();
    if (trimmed.length === 0)
        return false;
    if (INTERNAL_REF_PATTERN.test(trimmed))
        return true;
    return trimmed.includes("project_");
}
export function clientSafeProofReferenceLabel(input) {
    const fallback = input.headline?.trim() || input.reportTypeLabel?.trim() || "Launch proof";
    const raw = input.rawLabel?.trim();
    if (!raw)
        return "Launch proof summary";
    const inner = raw.startsWith("Launch proof · ")
        ? raw.slice("Launch proof · ".length).trim()
        : raw;
    if (isInternalProofReferenceRef(inner)) {
        return fallback;
    }
    if (inner === "Launch proof" || inner === "Launch proof summary") {
        return inner;
    }
    if (raw.startsWith("Launch proof · ") && !isInternalProofReferenceRef(inner)) {
        return inner;
    }
    if (!raw.startsWith("Launch proof")) {
        return inner;
    }
    return "Launch proof";
}
//# sourceMappingURL=client-safe-proof-reference-label.js.map